var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    incomeSources: {
        visited: false,
        anyIncome: false,
        incomeSources: [],
    },
    paymentMethods: {
        visited: false,
    },
    incomeSourceW2: {
        visited: false,
    },
    incomeSource1099: {
        visited: false,
    },
    incomeSourceBenefits: {
        visited: false,
    },
};
export var wizardSlice = createSlice({
    name: 'wizard',
    initialState: initialState,
    reducers: {
        setIncomeSources: function (state, action) { return (__assign(__assign({}, state), { incomeSources: action.payload })); },
        setIncomeSourceW2: function (state, action) { return (__assign(__assign({}, state), { incomeSourceW2: action.payload })); },
        setIncomeSource1099: function (state, action) { return (__assign(__assign({}, state), { incomeSource1099: action.payload })); },
        setIncomeSourceBenefits: function (state, action) { return (__assign(__assign({}, state), { incomeSourceBenefits: action.payload })); },
        setPaymentMethods: function (state, action) { return (__assign(__assign({}, state), { paymentMethods: action.payload })); },
    },
});
export var setIncomeSource1099 = (_a = wizardSlice.actions, _a.setIncomeSource1099), setIncomeSourceBenefits = _a.setIncomeSourceBenefits, setIncomeSourceW2 = _a.setIncomeSourceW2, setIncomeSources = _a.setIncomeSources, setPaymentMethods = _a.setPaymentMethods;
export var selectIncomeSources = function (state) {
    return state.wizard.incomeSources;
};
export var selectIncomeSourceW2 = function (state) {
    return state.wizard.incomeSourceW2;
};
export var selectIncomeSourceBenefits = function (state) {
    return state.wizard.incomeSourceBenefits;
};
export var selectIncomeSource1099 = function (state) {
    return state.wizard.incomeSource1099;
};
export var selectPaymentMethods = function (state) {
    return state.wizard.paymentMethods;
};
export var selectWizardState = function (state) { return state.wizard; };
export default wizardSlice.reducer;
